import React, { ReactNode } from "react";
import {
  Box,
  Drawer,
  Typography,
  IconButton,
  Button,
  alpha,
  useTheme,
  Icon,
} from "@mui/material";

interface FilterSidebarProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  onResetFilters?: () => void;
  onApplyFilters?: () => void;
  activeFiltersCount?: number;
}

export const FilterSidebar: React.FC<FilterSidebarProps> = ({
  open,
  onClose,
  title,
  children,
  onResetFilters,
  onApplyFilters,
  activeFiltersCount = 0,
}) => {
  const theme = useTheme();

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      variant="temporary"
      PaperProps={{
        sx: {
          width: 400,
          bgcolor: "background.paper",
          borderLeft: `1px solid ${alpha(theme.palette.divider, 0.12)}`,
        },
      }}
    >
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <Box
          sx={{
            p: 2,
            borderBottom: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Icon sx={{ color: "primary.main", fontSize: 20 }}>
              filter_list
            </Icon>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
            {activeFiltersCount > 0 && (
              <Box
                sx={{
                  bgcolor: "primary.main",
                  color: "white",
                  borderRadius: "50%",
                  width: 20,
                  height: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "0.7rem",
                  fontWeight: 600,
                }}
              >
                {activeFiltersCount}
              </Box>
            )}
          </Box>
          <IconButton onClick={onClose} size="small">
            <Icon>close</Icon>
          </IconButton>
        </Box>

        {/* Filter Content */}
        <Box sx={{ flex: 1, p: 2, overflowY: "auto" }}>{children}</Box>

        {/* Footer Actions */}
        <Box
          sx={{
            p: 2,
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.08)}`,
            display: "flex",
            gap: 1,
          }}
        >
          {onResetFilters && (
            <Button
              variant="outlined"
              onClick={onResetFilters}
              size="small"
              sx={{ flex: 1 }}
            >
              Reset
            </Button>
          )}
          {onApplyFilters && (
            <Button
              variant="contained"
              onClick={onApplyFilters}
              size="small"
              sx={{ flex: 1 }}
            >
              Apply Filters
            </Button>
          )}
        </Box>
      </Box>
    </Drawer>
  );
};
